// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vcqVi","header":"styles_header__9j0eB","date":"styles_date__D4pA+","prize":"styles_prize__nMbSZ","noWins":"styles_noWins__Nln14"};